import { Record, Set } from "immutable";
import { Moment, utc } from "moment";

import * as Legacy from "components/contacts/contacts-types";
import _ from "lodash";

export enum ConnectionStatus {
    PENDING = "pending" as any,
    APPROVED = "approved" as any,
    DENIED = "denied" as any,
    BLOCKED = "blocked" as any,
    REVIEW = "review" as any,
}

const defaults = {
    _id: "",
    user_id: "",
    brand_id: "",
    retailer_id: "",
    status: ConnectionStatus.PENDING,
    buyer_notes: "",
    brand_notes: Set(),
    response_reasons: "",
    created_on: undefined,
    status_updated_on: undefined,
    archived: false,
    __retailer: undefined,
};

export class ConnectionRequest extends Record(defaults) {
    declare _id: string;
    declare user_id: string;
    declare brand_id: string;
    declare retailer_id: string;
    declare status: ConnectionStatus;
    declare buyer_notes: string;
    declare brand_notes: string;
    declare response_reasons: string;
    declare created_on: Moment;
    declare status_updated_on: Moment;
    declare archived: boolean;
    declare pendingCount: number;
    declare __retailer: any; // TODO - this is in legacy format, not the retailer-profile one

    constructor(args) {
        super({
            ...args,
            created_on: utc(args.created_on),
            status_updated_on: utc(args.status_updated_on),
        });
    }

    get _retailerInitials() {
        if (!this.__retailer || !this.__retailer.name) {
            return "";
        }
        const words = this.__retailer.name.trim().split(/\s+/);
        const first = words[0][0];
        return (words[1] ? first + words[1][0] : first).toUpperCase();
    }

    get _retailerBuyers() {
        return (this.__retailer.modules.buyer.user_connections || []).map((buyer) => {
            return buyer.email;
        });
    }

    toLegacyCompany(rep: Legacy.ICompanyRep, scope: any): Legacy.ICompany {
        const connection = scope.brand._brandConnection;
        const address = _.get(this, "__retailer.addresses.0") as Legacy.IAddress;

        address.type = address.type || "both";
        address.default_billing = address.default_billing ?? true;
        address.default_shipping = address.default_shipping ?? true;

        const retailer = this.__retailer || {};
        const buyersConnection = retailer.modules
            ? _.find(retailer.modules.buyer.user_connections, { ref: this.user_id })
            : {};
        const reps = rep ? [rep] : [];
        const usingCustomRoles = scope.brand.hasPreference("allow_custom_roles");
        const buyerRoleOptions = scope.brand.getBuyerRoles();
        let roleName = "buyer";

        if (usingCustomRoles && buyerRoleOptions.length > 1) {
            roleName = buyerRoleOptions[0];
        }

        return {
            brand: this.brand_id,
            retailer_id: this.retailer_id,
            name: retailer.name,
            currency_codes: [connection.currency_code],
            warehouse:
                _.get(connection, "assigned_warehouses.0") || (_.first(scope.brand.settings.warehouses) as any)._id,
            addresses: [address],
            reps,
            customer_groups: [],
            user_connections: [
                {
                    name: buyersConnection.name,
                    ref: this.user_id,
                    email: buyersConnection.email,
                    role_name: roleName,
                    reps,
                    default_rep: rep,
                },
            ],
        };
    }
}
